const auth_mode = {
  ALL: 'all',
  ANY: 'any',
};

const user_roles = {
  ADMINISTRATIVE_APPROVER: {
    key: 'ADMINISTRATIVE_APPROVER',
    label: 'Administrative Approver',
  },
  ADMINISTRATOR: { key: 'ADMINISTRATOR', label: 'Administrator' },
  BUYER: { key: 'BUYER', label: 'Buyer' },
  BUDGETER: { key: 'BUDGETER', label: 'Budgeter' },
  PERMISSIONS_ADMINISTRATOR: {
    key: 'PERMISSIONS_ADMINISTRATOR',
    label: 'Permissions Administrator',
  },
  RECONCILER: { key: 'RECONCILER', label: 'Reconciler' },
  REPORT_ACCESSOR: { key: 'REPORT_ACCESSOR', label: 'Report Accessor' },
  REQUESTER: { key: 'REQUESTER', label: 'Requester' },
  SC_ADMIN: { key: 'SC_ADMIN', label: 'Service Contract Administrator' },
  TRANSACTOR: { key: 'TRANSACTOR', label: 'Transactor' },
  TRANS_IMPORTER: { key: 'TRANS_IMPORTER', label: 'Transaction Importer' },
  VENDOR_ADMINISTRATOR: {
    key: 'VENDOR_ADMINISTRATOR',
    label: 'Vendor Administrator',
  },
};

const user_org_roles = {
  MANAGER: { key: 'MANAGER', label: 'Manager' },
  MEMBER: { key: 'MEMBER', label: 'Member' },
  REQUEST_APPROVER: { key: 'REQUEST_APPROVER', label: 'Request Approver' },
};

const OBJECT_STATUS = {
  ACTIVE: {
    label: 'Active',
    key: 'ACTIVE',
  },
  DEACTIVATED: {
    label: 'Inactive',
    key: 'DEACTIVATED',
  },
};

const getObjectStatus = (key) => {
  return key ? OBJECT_STATUS[key] || key : '';
};

module.exports = {
  auth_mode,
  user_roles,
  user_org_roles,
  OBJECT_STATUS,
  getObjectStatus,
};
